import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import CricketIcon from "./../../assets/images/games-icon/throw.png";
import TennisIcon from "./../../assets/images/games-icon/tennis.png";
import horseracingIcon from "./../../assets/images/games-icon/horse.png";
import BasketballIcon from "./../../assets/images/games-icon/basketball.png";
import TableTennisIcon from "./../../assets/images/games-icon/table-tennis.png";
import PopularIcon from "./../../assets/images/games-icon/fire.png";
import UpcomingIcon from "./../../assets/images/games-icon/upcoming.png";
import LiveIcon from "./../../assets/images/games-icon/live.png";
import PromotionIcon from "./../../assets/images/games-icon/marketing.png";
import FavouriteIcon from "./../../assets/images/games-icon/favourite.png";
import FootballIcon from "./../../assets/images/games-icon/soccer-ball-variant.png";

const LeftBarSports = ({ onPopularClick }) => {
  const navigate = useNavigate();
  const { sportsData, oddsData, showBetSlip } = useSelector(
    (state) => state.sports,
  );

  const handleEventClick = (event) => {
    navigate(
      `/detail-page/${event?.marketSlug}/${event?.matchid}/${event?.marketid}/${event?.SportId}`,
    );
  };

  return (
    <>
      <div className="leftbarSec d-none d-md-block">
        <ul>
          <li className="games_link">
            <ul>
              <li>
                <div onClick={onPopularClick}>
                  <img src={PopularIcon} alt="Inplay" />
                  <span>Popular Games</span>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    navigate("/exchange/Inplay");
                  }}
                >
                  <img src={LiveIcon} alt="Inplay" />
                  <span>Live</span>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    navigate("/promotions");
                  }}
                >
                  <img src={PromotionIcon} alt="Cricket" />
                  <span>Promotions</span>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    navigate("/exchange/Cricket");
                  }}
                >
                  <img src={CricketIcon} alt="" />
                  <span>Cricket</span>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    navigate("/exchange/Soccer");
                  }}
                >
                  <img src={FootballIcon} alt="" />
                  <span>Football</span>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    navigate("/exchange/Basketball");
                  }}
                >
                  <img src={BasketballIcon} alt="Basketball" />
                  <span>Basketball</span>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    navigate("/exchange/Tennis");
                  }}
                >
                  <img src={TennisIcon} alt="" />
                  <span>Tennis</span>
                </div>
              </li>
              <li>
                <div
                  onClick={() => {
                    navigate("/exchange/TableTennis");
                  }}
                >
                  <img src={TableTennisIcon} alt="" />
                  <span>Table Tennis</span>
                </div>
              </li>

              <li>
                <div
                  onClick={() => {
                    navigate("/exchange/Horse%20Racing");
                  }}
                >
                  <img src={horseracingIcon} alt="horseracing" />
                  <span>Horseracing</span>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </>
  );
};

export default LeftBarSports;
